import { Route, Routes } from "react-router-dom";
import ComponentsPositiveYou from "./Views/PositiveYou";
import ComponentsHome from "./Views/ComponentsHome";
import { ComponentsWisdomAcademy } from "./Views/WisdomAcademy";
import { ComponentsWisdomRewards } from "./Views/WisdomRewards";
import { ComponentsSupportMoments } from "./Views/SupportMoments";
import ComponentsStudentHub from "./Views/StudentHub";
import ComponentsResources from "./Views/Resources";
import { ComponentsWisdomAI } from "./Views/WisdomAI";

export const Components = () => {
  return (
    <Routes>
      <Route index element={<ComponentsHome />}></Route>
      <Route path="positive-you" element={<ComponentsPositiveYou />} />
      <Route path="wisdom-academy" element={<ComponentsWisdomAcademy />} />
      <Route path="wisdom-reward" element={<ComponentsWisdomRewards />} />
      <Route path="support-moments" element={<ComponentsSupportMoments />} />
      <Route path="student-hub" element={<ComponentsStudentHub />} />
      <Route path="resources" element={<ComponentsResources />} />
      <Route path="wisdom-ai" element={<ComponentsWisdomAI />} />
    </Routes>
  );
};
